<template>
  <v-row class="pa-0 ">
    <v-speed-dial
      v-if="!loading && inscricaoLocal.matricula.status === 'CURSANDO'"
      v-model="speedDialModel"
      bottom
      left
      transition="slide-x-transition"
      direction="right"
    >
      <template v-slot:activator>
        <v-btn v-model="speedDialModel" color="pink" dark fab>
          <v-icon v-if="speedDialModel"> mdi-close </v-icon>
          <v-icon v-else>
            mdi-menu
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        v-if="inscricaoLocal.status === 'PENDENTE'"
        color="green dark-2"
        dark
        @click="isDeferindoAluno = !isDeferindoAluno"
      >
        {{ isDeferindoAluno ? "Deferindo aluno" : "Deferir" }}
      </v-btn>
      <v-btn
        v-if="
          inscricaoLocal.status === 'DESISTENTE' ||
            inscricaoLocal.status === 'INDEFERIDO'
        "
        color="primary"
        dark
        @click="onClickSpeedDialOption(retornarPendente)"
      >
        Retornar para Pendente
      </v-btn>

      <v-btn
        v-if="inscricaoLocal.status === 'DEFERIDO' && isEnturmadoVIN"
        color="blue darken-2"
        dark
        @click="isTransferindoAluno = !isTransferindoAluno"
      >
        {{ isTransferindoAluno ? "Transferindo aluno" : "Transferir" }}
        <v-icon v-if="isTransferindoAluno" class="ml-2"
          >mdi-close-circle-outline</v-icon
        >
      </v-btn>

      <v-btn
        v-if="
          inscricaoLocal.status === 'PENDENTE' ||
            (inscricaoLocal.status === 'DEFERIDO' &&
              (isEnturmadoVIN || isEnturmado))
        "
        dark
        color="orange darken-2"
        @click="onClickSpeedDialOption(desistir)"
      >
        Desistir
      </v-btn>

      <v-btn
        v-if="inscricaoLocal.status === 'PENDENTE'"
        dark
        color="red darken-2"
        @click="onClickSpeedDialOption(indeferir)"
      >
        Indeferir
      </v-btn>
    </v-speed-dial>

    <v-col cols="auto" class="d-flex justify-end flex-grow-1 flex-shrink-0">
      <CPTBtn
        label="Salvar"
        icon="mdi-content-save"
        :disabled="disableSaveButton"
        :loading="loading"
        @click="onSalvar"
      />
    </v-col>
  </v-row>
</template>

<script>
import CPTBtn from "@/components/Btn";
import {
  indeferir,
  desistir,
  retornarPendente,
  atualizar,
  transferir,
  deferir
} from "./acoes.js";

export default {
  name: "secao-acoes",
  components: {
    CPTBtn
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    unidadeEnsino: {
      type: Object,
      default: () => ({})
    },
    turma: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      required: true
    },
    transferindoAluno: {
      type: Boolean,
      required: true
    },
    deferindoAluno: {
      type: Boolean,
      required: true
    },
    enturmacoes: {
      type: Array,
      required: () => []
    }
  },
  data: () => ({
    speedDialModel: false,
    acao: "salvar"
  }),
  computed: {
    disableSaveButton() {
      return this.turma
        ? this.turma.id === this.enturmacoes[0]?.turma?.id ||
            this.turma.quantidadeAlunos >= this.turma.limiteAlunos ||
            this.turma?.etapa?.ordem < this.enturmacoes[0]?.turma?.etapa?.ordem
        : false;
    },
    inscricaoLocal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },

    isEnturmado() {
      return this.enturmacoes[0]?.turma?.apelido !== "VIN";
    },

    isEnturmadoVIN() {
      return this.enturmacoes[0]?.turma?.apelido === "VIN";
    },

    isTransferindoAluno: {
      get() {
        return this.transferindoAluno;
      },
      set(value) {
        this.$emit("update:transferindoAluno", value);
      }
    },

    isDeferindoAluno: {
      get() {
        return this.deferindoAluno;
      },
      set(value) {
        this.$emit("update:deferindoAluno", value);
      }
    }
  },

  methods: {
    indeferir,
    desistir,
    retornarPendente,

    async onClickSpeedDialOption(callback) {
      const response = await callback(this.inscricaoLocal);
      this.speedDialModel = !this.speedDialModel;
      this.showMessage(response.message, response.color);
      this.$emit("close");
    },

    async onSalvar() {
      if (this.isTransferindoAluno && this.isDeferindoAluno) {
        this.showMessage("Erro ao salvar inscrição", "error");
        return;
      }

      let response;

      if (this.isTransferindoAluno) {
        response = await transferir(
          this.value,
          this.turma,
          this.enturmacoes[0]
        );
      } else if (this.isDeferindoAluno) {
        response = await deferir(this.value, this.turma, this.enturmacoes[0]);
      } else {
        response = await atualizar(this.value);
      }

      this.showMessage(response.message, response.color);

      if (response.color !== "error") {
        this.$emit("close");
      }
    }
  }
};
</script>
